import { AnchorButton, H2 } from "@dgs/core";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const Center = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacing(6)};
`;

export function RegistrationFormPaymentOutstandingPage({ paymentLink }: { paymentLink: string }) {
	const { t } = useTranslation();

	return (
		<Center>
			<H2>{t("Complete Payment")}</H2>
			<span>{t("Please click on the button to finalise the payment!")}</span>
			<AnchorButton color="primary" href={paymentLink}>
				{t("Pay")}
			</AnchorButton>
		</Center>
	);
}
